import dayjs from 'dayjs';
import dayjsBusinessDays from 'dayjs-business-days';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(advancedFormat);
dayjs.extend(dayjsBusinessDays);

export default {
  install(app /* , options */) {
    app.config.globalProperties.$dayjs = dayjs;
  },
};

// eslint-disable-next-line unicorn/prefer-export-from
export { dayjs };
